import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_OCTOPUS_AUTO_AA_ML_DIGEST_NEW_ONBOARDING_CONFIG = defineFcm(
	'octopus_auto_aa_ml_digest_new_onboarding_config',
)
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				name: { type: 'string' },
				constraints: {
					type: 'array',
					shape: { type: 'string' },
				},
			},
		}),
	)
	.withDefault(undefined)
	.toConfig({
		owner: 'squad-site-platform',
		scope: 'TBD',
		context: 'comms stack',
		description:
			'Template experiment config for auto_aa_ml message type. Defines experiments used for the auto_aa_ml_digest_new_onboarding template. Leave the constraints empty [], to enable the experiment for all countries.',
		import: false,
		template: {
			name: '<experiment_name>',
			constraints: ['AR', 'AU', 'BR', 'CA', 'DE', 'ES', 'FR', 'GB', 'ID', 'IN', 'IT', 'JP', 'MX', 'TH', 'TR', 'US'],
		},
	});
